import { render, staticRenderFns } from "./AgreementConfirm.vue?vue&type=template&id=1ad46b55&scoped=true"
import script from "./AgreementConfirm.vue?vue&type=script&lang=js"
export * from "./AgreementConfirm.vue?vue&type=script&lang=js"
import style0 from "./AgreementConfirm.vue?vue&type=style&index=0&id=1ad46b55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad46b55",
  null
  
)

export default component.exports